import type { Meta, StoryFn } from '@storybook/react';

import { QRCode } from '@pega/cosmos-react-core';

export default {
  title: 'Core/QRCode',
  component: QRCode,
  args: {
    value: 'QRCode Demo',
    label: 'QRCode'
  },
  argTypes: {
    value: { type: 'string' },
    label: { type: 'string' }
  }
} as Meta;

interface QRCodeDemoProps {
  value: string;
  label: string;
}

export const QRCodeDemo: StoryFn<QRCodeDemoProps> = (args: QRCodeDemoProps) => {
  return <QRCode value={args.value} label={args.label} />;
};
